import { render, staticRenderFns } from "./PurchaseOfferingFlow.vue?vue&type=template&id=4784ba54&scoped=true"
import script from "./PurchaseOfferingFlow.vue?vue&type=script&lang=js"
export * from "./PurchaseOfferingFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4784ba54",
  null
  
)

export default component.exports